import { borderRadius, ButtonGroup } from '@toggle/design-system';
import styled, { css } from 'styled-components';

import { ChartAreaWrapper } from '~/components/chart-area-wrapper/ChartAreaWrapper';
import { ChartLoading } from '~/modules/simple-chart/components/chart-loading/ChartLoading';

export const PriceChartRoot = styled.div`
  position: relative;
`;

export const StyledChartAreaWrapper = styled(ChartAreaWrapper)`
  height: 240px;
`;

export const StyledButtonGroup = styled(ButtonGroup)<{
  $activeIndex: number;
}>`
  margin: 12px 0;
  width: fit-content;
  ${borderRadius.r3};
  border-width: 0px;
  background-color: var(--surface-default);

  ${ButtonGroup.Styles.ButtonGroupItem} {
    ${({ $activeIndex }) =>
      css`
        &:nth-child(${$activeIndex + 1}) {
          ${borderRadius.r2};
          border: 1px solid var(--text-primary);
          background-color: unset;
        }
      `}
  }
`;

export const DateDottedLine = styled.div<{ $left: number }>`
  border-left: 1px dashed var(--border-primary);
  position: absolute;
  top: 45px;
  left: ${({ $left }) => $left}px;
  width: 1px;
  height: 200px;
  z-index: 1;
`;

export const StyledChartLoading = styled(ChartLoading)`
  margin-top: 12px;
  min-height: unset;
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
